import React from 'react';
import { MEDIA_TYPE, MESSAGE_DIRECTION } from '@whatsper/texterchat-common';
import ImageMessage from '../../../../ImageMessage';
const StoryReply = ({ storyReply }) => {
    const inlineMedia = { url: storyReply === null || storyReply === void 0 ? void 0 : storyReply.url, mediaType: MEDIA_TYPE.IMAGE };
    return (React.createElement(ImageMessage, { messageId: storyReply === null || storyReply === void 0 ? void 0 : storyReply.id, media: inlineMedia, direction: MESSAGE_DIRECTION.OUT, imageMessages: [Object.assign(Object.assign({}, inlineMedia), { index: 0 })], showCaption: false }));
};
export default StoryReply;
